module.exports = __webpack_public_path__ + "static/img/3_1_8_1.197f048d.jpg";